// Shopping malls and their store directories. Each mall is one page; every
// entry inside it is a store the visitor can search, filter and open on its own
// detail card. Store names, categories and phone numbers come from the malls'
// own published directories; anything the mall does not publish is left out
// rather than guessed.

export const MALL_CATEGORIES = [
  { id: "fashion", en: "Fashion", es: "Moda" },
  { id: "shoes", en: "Shoes", es: "Calzado" },
  { id: "beauty", en: "Beauty", es: "Belleza" },
  { id: "jewelry", en: "Jewelry & watches", es: "Joyería y relojes" },
  { id: "electronics", en: "Electronics", es: "Electrónica" },
  { id: "home", en: "Home & department stores", es: "Hogar y departamentos" },
  { id: "food", en: "Food & restaurants", es: "Comida y restaurantes" },
  { id: "fun", en: "Entertainment", es: "Entretenimiento" },
  { id: "services", en: "Health & services", es: "Salud y servicios" },
  { id: "local", en: "Local shops & gifts", es: "Tiendas locales y regalos" },
  { id: "specialty", en: "Specialty", es: "Especialidad" },
];

const PLAZA_LOCAL = [
  { name: "Arte Arte", cat: "local", level: "Level 1", terms: "art local artist gifts" },
  { name: "Arte Madera y Cristal", cat: "local", terms: "wood glass handmade art" },
  { name: "Arte Religioso", cat: "local", level: "Level 2", terms: "religious art gifts" },
  { name: "Azúcar Morena", cat: "local", level: "Level 1", terms: "fashion boutique clothing" },
  { name: "Barras Jabón Artesanal", cat: "local", level: "Level 1", terms: "handmade soap skincare artisan" },
  { name: "Casa Febus", cat: "local", level: "Level 1", terms: "local gifts accessories" },
  { name: "Copped PR", cat: "local", level: "Level 2", terms: "sneakers streetwear puerto rico" },
  { name: "Diseños Fravier", cat: "local", level: "Level 2", terms: "design handmade accessories" },
  { name: "El Nido de Pícalo", cat: "local", terms: "local independent shop gifts" },
  { name: "Hecho a Mano", cat: "local", level: "Level 2", terms: "handmade crafts artisan puerto rico" },
  { name: "Hecho en Puerto Rico… La Tienda", cat: "local", level: "Level 3", terms: "puerto rico crafts local souvenirs gifts" },
  { name: "La Carreta Natural", cat: "local", level: "Level 1", terms: "natural wellness local products" },
  { name: "Latitud PRfecta", cat: "local", level: "Level 1", terms: "puerto rico gifts local design" },
  { name: "Lunanativa", cat: "local", level: "Level 1", terms: "local boutique accessories gifts" },
  { name: "M.Q. Mundillo de Moca", cat: "local", level: "Level 1", terms: "mundillo lace moca handmade craft" },
  { name: "PR Arts & Crafts — Paseo Cultural Ricardo Alegría", cat: "local", level: "Level 3", terms: "local art crafts handmade jewelry ceramics" },
  { name: "SOLA Boutique", cat: "local", level: "Level 2", terms: "boutique clothing accessories" },
  { name: "Tu Planta PR", cat: "local", level: "Level 2", terms: "plants local gifts" },
];

export const MALLS = [
  {
    id: "plaza-las-americas",
    path: "/plaza-las-americas",
    name: "Plaza Las Américas",
    area: "San Juan",
    image: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/df84cf912_generated_image.png",
    kickerEn: "The island's biggest mall",
    kickerEs: "El centro comercial más grande",
    blurbEn: "Department stores, the brands everyone knows and a whole floor of Puerto Rican makers.",
    blurbEs: "Tiendas por departamento, las marcas de siempre y un piso entero de creadores puertorriqueños.",
    officialUrl: "https://www.plazalasamericas.com/shops-and-services",
    officialLabelEn: "Official Plaza Las Américas directory",
    officialLabelEs: "Directorio oficial de Plaza Las Américas",
    entries: [
      { name: "Macy's", cat: "home", terms: "department store anchor" },
      { name: "JCPenney", cat: "home", terms: "department store anchor" },
      { name: "Sephora", cat: "beauty", terms: "makeup skincare beauty" },
      { name: "Bath & Body Works", cat: "beauty", terms: "candles soap fragrance" },
      { name: "Zara", cat: "fashion", terms: "fashion clothing" },
      { name: "H&M", cat: "fashion", terms: "fashion clothing" },
      { name: "Forever 21", cat: "fashion", terms: "fashion clothing" },
      { name: "Victoria's Secret", cat: "fashion", terms: "lingerie fashion" },
      { name: "Caribbean Cinemas", cat: "fun", terms: "movie theater cinema" },
      ...PLAZA_LOCAL,
    ],
  },
  {
    id: "san-patricio-plaza",
    path: "/san-patricio-plaza",
    name: "San Patricio Plaza",
    area: "Guaynabo",
    image: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/3ef864c3b_generated_image.png",
    kickerEn: "Guaynabo's everyday mall",
    kickerEs: "El centro comercial de todos los días en Guaynabo",
    blurbEn: "A neighborhood-scale plaza with independent shops, coffee and everyday services.",
    blurbEs: "Una plaza a escala de barrio con tiendas independientes, café y servicios del día a día.",
    officialUrl: "https://sanpatricio.com/establecimientos/propiedad/san-patricio-plaza/",
    officialLabelEn: "Official San Patricio Plaza directory",
    officialLabelEs: "Directorio oficial de San Patricio Plaza",
    entries: [
      { name: "Anhelomío Coffeetería", cat: "food", terms: "coffee desserts cafe local" },
      { name: "Appleberry", cat: "electronics", terms: "technology accessories electronics" },
      { name: "B-12 Store", cat: "specialty", terms: "wellness specialty retail" },
      { name: "Barbería San Patricio", cat: "services", terms: "barber grooming local" },
      { name: "Barras", cat: "beauty", terms: "beauty specialty products" },
      { name: "Blessings", cat: "local", terms: "gifts specialty shop" },
      { name: "Bloom", cat: "beauty", terms: "beauty wellness" },
      { name: "Ceci & Sofi", cat: "jewelry", terms: "jewelry accessories gifts" },
    ],
  },
  {
    id: "santa-rosa-mall",
    path: "/santa-rosa-mall",
    name: "Santa Rosa Mall",
    area: "Bayamón",
    image: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/45eb22d25_generated_image.png",
    kickerEn: "Bayamón, by the Tren Urbano",
    kickerEs: "Bayamón, junto al Tren Urbano",
    blurbEn: "Anchors, outlets and one of the island's two IKEA stores, a short walk from Deportivo station.",
    blurbEs: "Tiendas ancla, outlets y una de las dos tiendas IKEA de la isla, a pasos de la estación Deportivo.",
    hoursEn: "Mon–Sat 9am–7pm · Sun 11am–6pm",
    hoursEs: "Lun–Sáb 9am–7pm · Dom 11am–6pm",
    officialUrl: "https://www.santarosamallpr.com/en/tiendas/",
    officialLabelEn: "Official Santa Rosa Mall directory",
    officialLabelEs: "Directorio oficial de Santa Rosa Mall",
    entries: [
      { name: "IKEA", cat: "home", note: "Full IKEA store: furniture, kitchens and the food market.", noteEs: "Tienda IKEA completa: muebles, cocinas y el mercado de comida." },
      { name: "Almacenes Plaza", cat: "home" },
      { name: "Burlington", cat: "home" },
      { name: "Generators & More", cat: "home" },
      { name: "Caridad Outlets", cat: "fashion" },
      { name: "Charlotte Russe", cat: "fashion" },
      { name: "Me Salvé", cat: "fashion" },
      { name: "Novus Outlet", cat: "fashion" },
      { name: "Rainbow", cat: "fashion" },
      { name: "Bakers", cat: "shoes" },
      { name: "Emotion Beauty Supplies", cat: "beauty" },
      { name: "Ruby's Exotic Essence", cat: "beauty" },
      { name: "Exentrix", cat: "jewelry" },
      { name: "Golden Palace", cat: "jewelry" },
      { name: "Lebiram Steel", cat: "jewelry" },
      { name: "Humberto Vidal", cat: "services", note: "Hearing aids and audiology.", noteEs: "Audífonos y audiología." },
      { name: "Pearle Vision", cat: "services" },
      { name: "Nutrition World", cat: "services" },
      { name: "Banco Popular", cat: "services" },
      { name: "Claro", cat: "electronics" },
      { name: "T-Mobile", cat: "electronics" },
      { name: "All Ways 99", cat: "specialty" },
      { name: "IR Jabones Naturales", cat: "local" },
      { name: "Denny's", cat: "food" },
      { name: "Burger King", cat: "food" },
      { name: "Subway", cat: "food" },
    ],
  },
  {
    id: "plaza-del-sol",
    path: "/plaza-del-sol",
    name: "Plaza del Sol",
    area: "Bayamón",
    image: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/304e349e5_generated_image.png",
    kickerEn: "150+ stores in Bayamón",
    kickerEs: "Más de 150 tiendas en Bayamón",
    blurbEn: "The City of Arts and Sciences mall: anchors, a cinema, Dave & Buster's and a full food court.",
    blurbEs: "El centro comercial de la Ciudad de las Artes y las Ciencias: tiendas ancla, cine, Dave & Buster's y food court completo.",
    address: "725 West Main Ave, Ste 600, Bayamón",
    phone: "(787) 778-8724",
    hoursEn: "Mon–Sat 9am–9pm · Sun 11am–7pm",
    hoursEs: "Lun–Sáb 9am–9pm · Dom 11am–7pm",
    officialUrl: "https://curzon.pr/plazadelsol/",
    officialLabelEn: "Official Plaza del Sol directory",
    officialLabelEs: "Directorio oficial de Plaza del Sol",
    entries: [
      { name: "Walmart", cat: "home" },
      { name: "The Home Depot", cat: "home" },
      { name: "Burlington", cat: "home" },
      { name: "Me Salvé", cat: "fashion" },
      { name: "H&M", cat: "fashion" },
      { name: "Old Navy", cat: "fashion" },
      { name: "American Eagle", cat: "fashion" },
      { name: "Aeropostale", cat: "fashion" },
      { name: "Columbia", cat: "fashion" },
      { name: "Hot Topic", cat: "fashion" },
      { name: "Charlotte Russe", cat: "fashion" },
      { name: "Victoria's Secret", cat: "fashion" },
      { name: "Windsor", cat: "fashion" },
      { name: "Zumiez", cat: "fashion" },
      { name: "Kókomo", cat: "fashion" },
      { name: "La Gran Vía", cat: "fashion" },
      { name: "La Nueva Era", cat: "fashion" },
      { name: "The Room", cat: "fashion" },
      { name: "Valija", cat: "fashion" },
      { name: "Zafiro Clothing", cat: "fashion" },
      { name: "Sola Boutique", cat: "local" },
      { name: "Foot Locker", cat: "shoes", phone: "(787) 778-1715" },
      { name: "Kids Foot Locker", cat: "shoes", phone: "(787) 786-5100" },
      { name: "Finish Line", cat: "shoes", phone: "(787) 779-6601" },
      { name: "Champs", cat: "shoes", phone: "(787) 786-8614" },
      { name: "Journeys", cat: "shoes", phone: "(787) 778-1269" },
      { name: "Journeys Kidz", cat: "shoes", phone: "(787) 785-6475" },
      { name: "Aldo", cat: "shoes", phone: "(787) 787-2409" },
      { name: "Bakers", cat: "shoes", phone: "(787) 780-3914" },
      { name: "Skechers", cat: "shoes", phone: "(787) 780-1171" },
      { name: "Novus", cat: "shoes", phone: "(787) 778-1581" },
      { name: "Fit 2 Run", cat: "shoes", phone: "(939) 206-5005" },
      { name: "Bath & Body Works", cat: "beauty", phone: "(787) 787-5685" },
      { name: "Sally Beauty Supply", cat: "beauty", phone: "(787) 778-2177" },
      { name: "JF Perfume's", cat: "beauty", phone: "(787) 219-0239" },
      { name: "Brow Art 23", cat: "beauty" },
      { name: "AZ Salon", cat: "beauty", phone: "(787) 900-5332" },
      { name: "Pandora", cat: "jewelry", phone: "(787) 785-0532" },
      { name: "Tous", cat: "jewelry", phone: "(787) 200-1393" },
      { name: "Uno de 50", cat: "jewelry", phone: "(939) 206-5321" },
      { name: "Claire's", cat: "jewelry", phone: "(787) 780-7117" },
      { name: "Beya", cat: "jewelry", phone: "(787) 798-7354" },
      { name: "Cuesta", cat: "jewelry", phone: "(787) 740-8543" },
      { name: "Exentrix", cat: "jewelry", phone: "(787) 778-1898" },
      { name: "Lids", cat: "specialty", phone: "(787) 780-3968" },
      { name: "Claro", cat: "electronics", phone: "(787) 995-5120" },
      { name: "T-Mobile", cat: "electronics", phone: "(787) 995-0176" },
      { name: "Liberty Mobile", cat: "electronics", phone: "(787) 920-1370" },
      { name: "The FIX", cat: "electronics", phone: "(787) 994-2626" },
      { name: "Cellairis", cat: "electronics", phone: "(939) 438-1160" },
      { name: "Elite Phone Armor", cat: "electronics", phone: "(787) 909-4399" },
      { name: "Caribbean Cinemas", cat: "fun", phone: "(787) 288-3284", note: "Movie theater inside the mall.", noteEs: "Cine dentro del centro comercial." },
      { name: "Dave & Buster's", cat: "fun", phone: "(787) 545-7159", note: "Arcade, sports bar and restaurant.", noteEs: "Arcade, sports bar y restaurante." },
      { name: "At the Pier Arcade", cat: "fun", phone: "(787) 780-0067" },
      { name: "Chick-fil-A", cat: "food", phone: "(787) 302-3033" },
      { name: "Chili's", cat: "food", phone: "(787) 778-8811" },
      { name: "Church's Chicken", cat: "food", phone: "(787) 786-1366" },
      { name: "El Mesón Sandwiches", cat: "food", phone: "(787) 778-0075" },
      { name: "Porky's Restaurant", cat: "food", phone: "(787) 740-7646" },
      { name: "Starbucks Coffee", cat: "food", phone: "(787) 626-0142" },
      { name: "Taco Bell", cat: "food", phone: "(787) 269-3585" },
      { name: "Auntie Anne's", cat: "food" },
      { name: "Cinnabon", cat: "food", phone: "(939) 539-4552" },
      { name: "Wetzel's Pretzels", cat: "food", phone: "(787) 785-7210" },
      { name: "Casa Mofongo Express", cat: "food", phone: "(787) 624-9977" },
      { name: "David's Cookies", cat: "food", phone: "(787) 778-0597" },
      { name: "Soft & Creamy", cat: "food", phone: "(787) 740-2121" },
      { name: "The Hot Potato", cat: "food", phone: "(787) 269-1566" },
      { name: "Ricolandia", cat: "food", phone: "(939) 247-6397" },
      { name: "LensCrafters", cat: "services", phone: "(787) 808-6870" },
      { name: "For Eyes", cat: "services", phone: "(787) 966-7473" },
      { name: "Eye Center Boutique", cat: "services", phone: "(787) 780-4444" },
      { name: "Del Sol Dental Care", cat: "services", phone: "(787) 780-4300" },
      { name: "Farmacias Plaza", cat: "services", phone: "(787) 620-9606" },
      { name: "Banco Popular", cat: "services", phone: "(787) 778-3190" },
      { name: "First Bank", cat: "services", phone: "(787) 778-2525" },
      { name: "Pep Boys", cat: "services", phone: "(787) 798-2700" },
      { name: "All Ways 99", cat: "specialty", phone: "(787) 786-4991" },
      { name: "Miniso", cat: "specialty" },
      { name: "Box Lunch", cat: "specialty", phone: "(787) 620-2679" },
      { name: "Oriental Shop", cat: "specialty" },
    ],
  },
  {
    id: "mall-of-san-juan",
    path: "/mall-of-san-juan",
    name: "The Mall of San Juan",
    area: "San Juan",
    image: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/c3595b6b5_generated_image.png",
    kickerEn: "The island's luxury mall",
    kickerEs: "El centro comercial de lujo de la isla",
    blurbEn: "Cartier, Gucci, Louis Vuitton and Zara under one roof, across from the San José Lagoon and minutes from the airport.",
    blurbEs: "Cartier, Gucci, Louis Vuitton y Zara bajo un mismo techo, frente a la laguna San José y a minutos del aeropuerto.",
    address: "1000 The Mall of San Juan Blvd, San Juan, PR 00924",
    hoursEn: "Mon–Thu 10am–8pm · Fri 10am–9pm · Sat–Sun 10am–7pm",
    hoursEs: "Lun–Jue 10am–8pm · Vie 10am–9pm · Sáb–Dom 10am–7pm",
    officialUrl: "https://www.simon.com/mall/the-mall-of-san-juan/stores",
    officialLabelEn: "Official The Mall of San Juan directory",
    officialLabelEs: "Directorio oficial de The Mall of San Juan",
    entries: [
      { name: "120% Lino", cat: "fashion", level: "Level 2" },
      { name: "Anthropologie", cat: "fashion", level: "Level 2" },
      { name: "Arrecife", cat: "fashion", level: "Level 1" },
      { name: "Atypical Living", cat: "home", level: "Level 1" },
      { name: "AutoLux", cat: "specialty", level: "Level 1" },
      { name: "Aviles Auto", cat: "specialty", level: "Level 1" },
      { name: "Banana Republic", cat: "fashion", level: "Level 1" },
      { name: "Hub Digital Banco Popular", cat: "services", level: "Level 1" },
      { name: "Bared", cat: "shoes", level: "Level 2" },
      { name: "Bath & Body Works", cat: "beauty", level: "Level 1" },
      { name: "Bimba y Lola", cat: "fashion", level: "Level 2" },
      { name: "Blanca Fragrance Factory", cat: "beauty", level: "Level 1" },
      { name: "Boss Hugo Boss", cat: "fashion", level: "Level 2" },
      { name: "Bvlgari", cat: "jewelry", level: "Level 2" },
      { name: "Cafeto", cat: "food", level: "Level 1", note: "Coffee, pastries and sandwiches by the Grand Court.", noteEs: "Café, pastelillos y sándwiches junto al Grand Court." },
      { name: "Calzedonia", cat: "fashion", level: "Level 1" },
      { name: "Caribbean Rentals", cat: "specialty", level: "Level 1" },
      { name: "Cartier", cat: "jewelry", level: "Level 2" },
      { name: "CH Carolina Herrera", cat: "fashion", level: "Level 2" },
      { name: "Claro Store", cat: "electronics", level: "Level 1" },
      { name: "Coach", cat: "fashion", level: "Level 2" },
      { name: "Cocoa & Crumbles", cat: "food", level: "Level 1" },
      { name: "Coquetisima", cat: "fashion", level: "Level 1" },
      { name: "CXC", cat: "specialty", level: "Level 1" },
      { name: "Designer Eyes", cat: "services", level: "Level 1" },
      { name: "Doctor Sleep", cat: "home", level: "Level 1" },
      { name: "Dr. Tech", cat: "electronics", level: "Level 1" },
      { name: "El Patio", cat: "food", level: "Level 1" },
      { name: "Elenika Jewelry", cat: "jewelry", level: "Level 1" },
      { name: "ENZO", cat: "jewelry", level: "Level 2" },
      { name: "Eye Center Boutique", cat: "services", level: "Level 1" },
      { name: "Ferragamo", cat: "shoes", level: "Level 2" },
      { name: "Fit2Run", cat: "shoes", level: "Level 2" },
      { name: "Free People", cat: "fashion", level: "Level 2" },
      { name: "GAP & GAP KIDS", cat: "fashion", level: "Level 1" },
      { name: "Golden Goose", cat: "shoes", level: "Level 2" },
      { name: "Gucci", cat: "fashion", level: "Level 2" },
      { name: "Gustavo Arango", cat: "specialty", level: "Level 2" },
      { name: "H&M", cat: "fashion", level: "Level 1" },
      { name: "Hazel Bar", cat: "food", level: "Level 1" },
      { name: "Hollister", cat: "fashion", level: "Level 1" },
      { name: "Hugo", cat: "fashion", level: "Level 2" },
      { name: "Il Nuovo Mercato", cat: "food", level: "Level 3", note: "Italian food hall on the top level.", noteEs: "Food hall italiano en el último nivel." },
      { name: "Intimissimi", cat: "fashion", level: "Level 1" },
      { name: "Inventus", cat: "specialty", level: "Level 1" },
      { name: "It Girl", cat: "fashion", level: "Level 1" },
      { name: "It Vogue Boutique", cat: "fashion", level: "Level 2" },
      { name: "Janie and Jack", cat: "fashion", level: "Level 1" },
      { name: "JD", cat: "shoes", level: "Level 1" },
      { name: "Jimmy Choo", cat: "shoes", level: "Level 2" },
      { name: "Kokii", cat: "specialty", level: "Level 1" },
      { name: "Krispy Kreme Doughnuts", cat: "food", level: "Level 1" },
      { name: "La Favorita", cat: "fashion", level: "Level 1" },
      { name: "lala", cat: "food", level: "Level 1", note: "Global flavors at the north entrance.", noteEs: "Sabores del mundo en la entrada norte." },
      { name: "La Lueur", cat: "jewelry", level: "Level 2" },
      { name: "LatitudPRfecta", cat: "local", level: "Level 1" },
      { name: "Letran", cat: "specialty", level: "Level 1" },
      { name: "Liberty", cat: "electronics", level: "Level 1" },
      { name: "LICK", cat: "food", level: "Level 1" },
      { name: "Lido Jewelers", cat: "jewelry", level: "Level 2" },
      { name: "Little Switzerland", cat: "jewelry", level: "Level 2" },
      { name: "Llaves y Beepers", cat: "services", level: "Level 1" },
      { name: "Louis Vuitton", cat: "fashion", level: "Level 2" },
      { name: "Lovisa", cat: "jewelry", level: "Level 1" },
      { name: "LUSH Fresh Handmade Cosmetics", cat: "beauty", level: "Level 1" },
      { name: "Lyora", cat: "fashion", level: "Level 1" },
      { name: "Maceoo", cat: "shoes", level: "Level 2" },
      { name: "Mercato Rooftop", cat: "food", level: "Level 3", note: "Rooftop Italian dining above the food hall.", noteEs: "Comida italiana en la azotea, sobre el food hall." },
      { name: "Metropol Restaurant & Bar", cat: "food", level: "Level 1" },
      { name: "MIMI", cat: "fashion", level: "Level 1" },
      { name: "Molécula Salon", cat: "services", level: "Level 1" },
      { name: "New In The Box", cat: "specialty", level: "Level 1" },
      { name: "Nouvelle D'Spa", cat: "services", level: "Level 2" },
      { name: "Novus", cat: "shoes", level: "Level 1" },
      { name: "Off-White", cat: "fashion", level: "Level 2" },
      { name: "OLY", cat: "fashion", level: "Level 1" },
      { name: "OMEGA Boutique", cat: "jewelry", level: "Level 2" },
      { name: "Palettamerica", cat: "specialty", level: "Level 1" },
      { name: "Pandora", cat: "jewelry", level: "Level 1" },
      { name: "Pash.On", cat: "fashion", level: "Level 1" },
      { name: "Pickleball at the Mall", cat: "fun", level: "Level 2", note: "Indoor pickleball courts.", noteEs: "Canchas de pickleball bajo techo." },
      { name: "Playero", cat: "fashion", level: "Level 2" },
      { name: "Pottery Barn", cat: "home", level: "Level 2" },
      { name: "Psycho Bunny", cat: "fashion", level: "Level 2" },
      { name: "Saint Laurent", cat: "fashion", level: "Level 2" },
      { name: "Salt.", cat: "food", level: "Level 1" },
      { name: "Salud Natural", cat: "services", level: "Level 1" },
      { name: "Santa Photo Experience", cat: "fun", level: "Level 1" },
      { name: "Seasons by Atypical Living", cat: "home", level: "Level 2" },
      { name: "ShuShop", cat: "shoes", level: "Level 1" },
      { name: "Silbon", cat: "fashion", level: "Level 1" },
      { name: "Starbene Caffe", cat: "food", level: "Level 3" },
      { name: "Sumaq", cat: "specialty", level: "Level 1" },
      { name: "T-Mobile", cat: "electronics", level: "Level 1" },
      { name: "TAG HEUER", cat: "jewelry", level: "Level 2" },
      { name: "Tesla", cat: "specialty", level: "Level 1", note: "Tesla showroom.", noteEs: "Sala de exhibición Tesla." },
      { name: "The B12 Store", cat: "services", level: "Level 1" },
      { name: "The Coffee", cat: "food", level: "Level 1" },
      { name: "The Fashion Lounge", cat: "fashion", level: "Level 1" },
      { name: "The Fix", cat: "electronics", level: "Level 1" },
      { name: "Tiendas Roma", cat: "shoes", level: "Level 1" },
      { name: "Tiffany & Co.", cat: "jewelry", level: "Level 2" },
      { name: "Tijuana's Bar & Grill", cat: "food", level: "Level 2" },
      { name: "Tommy Bahama", cat: "fashion", level: "Level 2" },
      { name: "Tory Burch", cat: "fashion", level: "Level 2" },
      { name: "Tous", cat: "jewelry", level: "Level 1" },
      { name: "TUMI", cat: "specialty", level: "Level 2" },
      { name: "Urban Beauty Supply", cat: "beauty", level: "Level 1" },
      { name: "Urban Outfitters", cat: "fashion", level: "Level 1" },
      { name: "Valentino Valentin", cat: "specialty", level: "Level 1" },
      { name: "Vans", cat: "shoes", level: "Level 1" },
      { name: "Versace", cat: "fashion", level: "Level 2" },
      { name: "VG Optical", cat: "services", level: "Level 2" },
      { name: "Victoria's Secret", cat: "fashion", level: "Level 1" },
      { name: "Vin'Us", cat: "food", level: "Level 2" },
      { name: "Williams Sonoma", cat: "home", level: "Level 2" },
      { name: "Yummy Fru", cat: "food", level: "Level 1" },
      { name: "Zafiro Clothing", cat: "fashion", level: "Level 2" },
      { name: "Zara", cat: "fashion", level: "Level 1" },
      { name: "Zimmermann", cat: "fashion", level: "Level 2" },
      { name: "ART | Aesthetic Regenerative Therapies", cat: "services", level: "Level 1" },
    ],
  },
];

export const getMall = (id) => MALLS.find((mall) => mall.id === id) || MALLS[0];

export const categoryLabel = (id, lang = "en") => {
  const found = MALL_CATEGORIES.find((category) => category.id === id);
  if (!found) return "";
  return lang === "es" ? found.es : found.en;
};